import { render, staticRenderFns } from "./AnnualPower.vue?vue&type=template&id=06520044&scoped=true&"
import script from "./AnnualPower.vue?vue&type=script&lang=js&"
export * from "./AnnualPower.vue?vue&type=script&lang=js&"
import style0 from "./AnnualPower.vue?vue&type=style&index=0&id=06520044&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06520044",
  null
  
)

export default component.exports